import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-method"
export default class extends Controller {
  static targets = ["select", "checkNumberField"]

  connect() {
    this.toggleCheckNumber()
  }

  selectChanged() {
    this.toggleCheckNumber()
  }

  toggleCheckNumber() {
    const paymentMethod = this.selectTarget.value
    const checkNumberField = this.checkNumberFieldTarget
    
    if (paymentMethod === "check") {
      checkNumberField.disabled = false
      checkNumberField.required = true
      checkNumberField.classList.remove("bg-gray-100")
    } else {
      checkNumberField.disabled = true
      checkNumberField.required = false
      checkNumberField.value = ""
      checkNumberField.classList.add("bg-gray-100")
    }
  }
}
